
import { Component } from 'vue-property-decorator';
import ElementBase from '../ElementBase';
import { AuditHistoryEntry } from '../../../backend/backendapi';
import LineChart from "./LineChart";
import { formatDateForInput, parseDateTimeFromInput } from "../../../../util";

@Component({
  name: 'AuditHistoryChart',
  components: { LineChart },
})
export default class AuditHistoryChart extends ElementBase {
  readonly auditHistory: AuditHistoryEntry[] = [];
  dateFrom: Date;
  dateTo: Date;

  get dateFromAsString(): string {
    return formatDateForInput(this.dateFrom);
  }

  set dateFromAsString(val: string) {
    this.dateFrom = this.correctDateFrom(parseDateTimeFromInput(val));
  }

  get dateToAsString(): string {
    return formatDateForInput(this.dateTo);
  }

  set dateToAsString(val: string) {
    this.dateTo = this.correctDateTo(parseDateTimeFromInput(val));
  }

  get filteredHistory(): AuditHistoryEntry[] {
    return this.auditHistory.filter(e => (this.dateFrom.getFullYear() < e.year
            || (this.dateFrom.getFullYear() == e.year && this.dateFrom.getMonth() + 1 <= e.month))
        && (e.year < this.dateTo.getFullYear()
            || (e.year == this.dateTo.getFullYear() && e.month <= this.dateTo.getMonth() + 1)));
  }

  constructor() {
    super();
    this.lastDataUpdate = new Date(0);
    this.timeoutSeconds = 120;

    this.dateTo = this.correctDateTo(new Date());
    this.dateFrom = this.correctDateFrom(new Date());
    this.dateFrom.setMonth(this.dateFrom.getMonth() - 12);
  }

  async mounted(): Promise<void> {
    await super.mounted();
    this.enableTimeout();
  }

  public onInformationPush(elementPath: string, json: string): void {
    super.onInformationPush(elementPath, json);

    if (elementPath !== this.elementPath) {
      return;
    }

    const update = JSON.parse(json);
    Object.entries(update).forEach(([key, value]) => {
      if (key === 'auditHistory') {
        const update = value as AuditHistoryEntry[];
        update.forEach(e => (e as any).date = new Date(e.year, e.month - 1, 1));
        if (JSON.stringify(update) !== JSON.stringify(this.auditHistory)) {
          this.auditHistory.splice(0);
          this.auditHistory.push(...update);
        }
        this.lastDataUpdate = new Date();
      }
    });
  }

  protected get bindingsContext(): any {
    const context = Reflect.get(ElementBase.prototype, 'bindingsContext', this);
    Object.defineProperty(context, 'dateFrom', { get: () => this.dateFrom });
    Object.defineProperty(context, 'dateTo', { get: () => this.dateTo });
    return context;
  }

  private correctDateFrom(date: Date): Date {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  private correctDateTo(date: Date): Date {
    date.setMonth(date.getMonth() + 1);
    date.setDate(0);
    date.setHours(23, 59, 59, 999);
    return date;
  }
}
